import update from 'immutability-helper';

import { RequiredArticle } from '../../../../../interfaces/Article';
import { Configuration } from '../../../../../interfaces/Configuration';
import { SocketType } from '../../../../../interfaces/SocketType';

export const replaceRequiredLightingArticleInConfiguration = (
  configuration: Configuration,
  oldArticleId: string,
  newArticle: RequiredArticle,
  newSocketType: SocketType,
): Configuration => {
  const requiredArticles = configuration.requiredLightingArticles.map((article) =>
    article.id === oldArticleId ? newArticle : article,
  );

  const index = configuration.articles.findIndex((article) =>
    article.requiredLightingArticlesIds.includes(oldArticleId),
  );

  const newIds = configuration.articles[index].requiredLightingArticlesIds.map((id) =>
    id === oldArticleId ? newArticle.id : id,
  );

  const articles = update(configuration.articles, {
    [index]: { requiredLightingArticlesIds: { $set: newIds } },
  });

  return update(configuration, {
    socketType: {
      $set: newSocketType,
    },
    articles: {
      $set: articles,
    },
    requiredLightingArticles: {
      $set: requiredArticles,
    },
  });
};
